import * as React from "react";
import { FC } from "react";
import { PopupBody, PopupHeader, Popup, PopupFooter } from "./Popup";
import { useAppContext } from "../Contexts/AppContext";
import { CloseButton } from "../Elements/CloseButton";
import { useMapContext } from "../Contexts/MapContext";

export const HelpPopup: FC = () => {
    const { isMobile } = useAppContext();
    const { setDrawingInfoVisible } = useMapContext();

    const text1 = "Norādiet kartē pasākuma norises vietu un ar to saistītos objektus.";
    const text2 =
        "Pasākuma maršruta datus var iezīmēt kartē kā līnijveida un laukumveida objektus vai pievienot kā pielikumu pieteikuma pēdējā solī (gpx, kml vai citā datu formā).";
    const text3 = "Interesējošo kartes apgabalu iespējams pietuvināt meklētājā norādot novadu vai pagastu.";

    return (
        <Popup id={"help-popup"} sameContainer={true} isMobile={false} hasBackdrop={true} className={"relative"}>
            <PopupHeader isMobile={isMobile}>
                {!isMobile && <div>Iezīmēt pasākuma norises vietu</div>}
                <CloseButton onClose={() => setDrawingInfoVisible(false)}></CloseButton>
            </PopupHeader>
            <PopupBody isMobile={isMobile}>
                <div>{text1}</div>
                <div>{text2}</div>
                <div>{text3}</div>
            </PopupBody>
            <PopupFooter isMobile={isMobile}></PopupFooter>
        </Popup>
    );
};
